// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__39vPo","approved":"Status_approved__3QXLV","rejected":"Status_rejected__SxE5V","expired":"Status_expired__1xyjW","label":"Status_label__PJpRQ"};